
import Utils from './utils';
import * as keys from './keys';

const FormObserver = (formRef, props) => {

  formRef.$('policy-term').observe({
    key: 'value',
    call: ({ field }) => {
      const ptValue = field.value.id

      let pptValue;
      let payoutPeriodValue;

      switch (ptValue) {

        // For PT = 6, PPT = 1 (by default and uneditable), Payout Period = 6 (by default and uneditable)
        case 6:
          formRef.$('premium-term').set('value',{id: 1, label: '1'})
          formRef.$('premium-term').set('disabled',true)

          formRef.$('payout-period').set('value',{id: 1, label: '6'})
          formRef.$('payout-period').set('disabled',true)

           pptValue = formRef.$('premium-term').value.id
           payoutPeriodValue = formRef.$('payout-period').value.id

          Utils.updateBi(keys.PR_PT, field.value.id, props.data.product_id, formRef, props)
          Utils.updateBi(keys.PR_PPT, pptValue, props.data.product_id, formRef, props)
          Utils.updateBi(keys.PAYOUT_PERIOD, payoutPeriodValue, props.data.product_id, formRef, props)
          
          break;

          // For PT = 7, PPT = 7 (by default and uneditable), Payout Period = 7 (by default and editable), 13, 18, 23
          case 7:
            formRef.$('premium-term').set('value',{id: 7, label: '7'})
            formRef.$('premium-term').set('disabled',true)
  
            formRef.$('payout-period').set('value',{id: 2, label: '7'})
            formRef.$('payout-period').set('extra',{
              ...formRef.$('payout-period').extra,
              optionList: [{id: 6, label: '13'},{id: 8, label: '18'},{id: 10, label: '23'}]
          })
            formRef.$('payout-period').set('disabled',false)
  
            pptValue = formRef.$('premium-term').value.id
            payoutPeriodValue = formRef.$('payout-period').value.id
  
            Utils.updateBi(keys.PR_PT, field.value.id, props.data.product_id, formRef, props)
            Utils.updateBi(keys.PR_PPT, pptValue, props.data.product_id, formRef, props)
            Utils.updateBi(keys.PAYOUT_PERIOD, payoutPeriodValue, props.data.product_id, formRef, props)
            
            break;

            // For PT = 8, PPT = 1 (by default and uneditable), Payout Period = 8 (by default and uneditable)
            case 8:
              formRef.$('premium-term').set('value',{id: 1, label: '1'})
              formRef.$('premium-term').set('disabled',true)
    
              formRef.$('payout-period').set('value', {id: 3, label: '8'})
              formRef.$('payout-period').set('disabled',true)
    
              pptValue = formRef.$('premium-term').value.id
              payoutPeriodValue = formRef.$('payout-period').value.id
    
              Utils.updateBi(keys.PR_PT, field.value.id, props.data.product_id, formRef, props)
              Utils.updateBi(keys.PR_PPT, pptValue, props.data.product_id, formRef, props)
              Utils.updateBi(keys.PAYOUT_PERIOD, payoutPeriodValue, props.data.product_id, formRef, props)
              
              break;

              // For PT = 10, PPT = 10 (by default and editable), 1; Payout Period = 10 (by default and uneditable if PPT = 1); 10 (by default and editable if PPT =10), 15, 20
              case 10:
                formRef.$('premium-term').set('value',{id: 10, label: '10'})
                formRef.$('premium-term').set('extra',{
                  ...formRef.$('premium-term').extra,
                  optionList: [{id: 1, label: '1'},{id: 10, label: '10'}]
              })
                formRef.$('premium-term').set('disabled',false)
      
                formRef.$('payout-period').set('value', {id: 4, label: '10'})
                
                formRef.$('payout-period').set('extra',{
                  ...formRef.$('payout-period').extra,
                  optionList: [{id: 4, label: '10'},{id: 7, label: '15'},{id: 9, label: '20'}]
              })
                formRef.$('payout-period').set('disabled',false)
      
                pptValue = formRef.$('premium-term').value.id
                payoutPeriodValue = formRef.$('payout-period').value.id
      
                Utils.updateBi(keys.PR_PT, field.value.id, props.data.product_id, formRef, props)
                Utils.updateBi(keys.PR_PPT, pptValue, props.data.product_id, formRef, props)
                Utils.updateBi(keys.PAYOUT_PERIOD, payoutPeriodValue, props.data.product_id, formRef, props)

                break;

                // For PT = 12, PPT = 12 (by default and editable), 1; Payout Period = 12 (by default and uneditable if PPT = 1); 12 (by default and editable if PPT = 12), 18
                case 12:
                  formRef.$('premium-term').set('value',{id: 12, label: '12'})
                  formRef.$('premium-term').set('extra',{
                    ...formRef.$('premium-term').extra,
                    optionList: [{id: 1, label: '1'},{id: 12, label: '12'}]
                })
                  formRef.$('premium-term').set('disabled',false)
        
                  formRef.$('payout-period').set('value', {id: 5, label: '12'})
                  formRef.$('payout-period').set('extra',{
                    ...formRef.$('payout-period').extra,
                    optionList: [{id: 5, label: '12'},{id: 8, label: '18'}]
                })
                  formRef.$('payout-period').set('disabled',false)
        
                  pptValue = formRef.$('premium-term').value.id
                  payoutPeriodValue = formRef.$('payout-period').value.id
        
                  Utils.updateBi(keys.PR_PT, field.value.id, props.data.product_id, formRef, props)
                  Utils.updateBi(keys.PR_PPT, pptValue, props.data.product_id, formRef, props)
                  Utils.updateBi(keys.PAYOUT_PERIOD, payoutPeriodValue, props.data.product_id, formRef, props)
  
                  break;
      
        default:

          formRef.$('premium-term').set('extra',{
            ...formRef.$('premium-term').extra,
            optionList: Utils.generatePPT()
        })

        formRef.$('payout-period').set('extra',{
          ...formRef.$('payout-period').extra,
          optionList: Utils.getPayoutPeriodList()
      })


          break;
      }


      Utils.updateBi(keys.PR_PT, field.value.id, props.data.product_id, formRef, props)
    }
  })

  formRef.$('premium-term').observe({
    key: 'value',
    call: ({ field }) => {


      let ptValue = formRef.$('policy-term').value.id
      let pptValue = formRef.$('premium-term').value.id

// For PT = 10, PPT = 10 (by default and editable), 1; Payout Period = 10 (by default and uneditable if PPT = 1); 10 (by default and editable if PPT=10), 15, 20
      if(ptValue === 10 && pptValue === 1){
        formRef.$('payout-period').set('value', {id: 4, label: '10'})
        formRef.$('payout-period').set('disabled',true)
      }else if(ptValue === 12 && pptValue === 1){
        // For PT = 12, PPT = 12 (by default and editable), 1; Payout Period = 12 (by default and uneditable if PPT = 1); 12 (by default and editable if PPT = 12), 18
        formRef.$('payout-period').set('value', {id: 5, label: '12'})
        formRef.$('payout-period').set('disabled',true)
      }else{
        formRef.$('payout-period').set('disabled',false)
      }

      let payoutPeriodValue = formRef.$('payout-period').value.id
      Utils.updateBi(keys.PAYOUT_PERIOD, payoutPeriodValue, props.data.product_id, formRef, props)


      if(field.value.id === 1){
        formRef.$('payment-frequency').set('disabled', true)
        formRef.$('payment-frequency').set('value', {
            id: '5',
            label: 'Single'
        })

        formRef.$('payment-frequency').set("extra", {
          ...formRef.$('payment-frequency').extra,
          optionList: Utils.generatePPF(field.value.id)
      })
    }else{
      formRef.$('payment-frequency').set('value', Utils.generatePPF(field.value.id)[0])
      formRef.$('payment-frequency').set('disabled', false)
    }
      Utils.updateBi(keys.PR_PPT, field.value.id, props.data.product_id, formRef, props)
    }
  })

  formRef.$('payment-frequency').observe({
    key: 'value',
    call: ({ field }) => {
      let premium = formRef.$('premium').value
      let frequency = field.value.id
      let data = {
        premium: premium,
        frequency: frequency
      }
      Utils.updateBi(keys.FREQUENCY, data, props.data.product_id, formRef, props)
    }
  })
  formRef.$('payout-period').observe({
    key: 'value',
    call: ({ field }) => {
      Utils.updateBi(keys.PAYOUT_PERIOD, field.value.id, props.data.product_id, formRef, props)
    }
  })
  formRef.$('option-name').observe({
    key: 'value',
    call: ({ field }) => {
      Utils.updateBi(keys.OPTION_NAME, field.value.id, props.data.product_id, formRef, props)
    }
  })
  formRef.$('maturity-benefit-option').observe({
    key: 'value',
    call: ({ field }) => {
      Utils.updateBi(keys.MATURITY_BENEFIT_OPTION, field.value.id, props.data.product_id, formRef, props)
    }
  })
  formRef.$('payout-mode').observe({
    key: 'value',
    call: ({ field }) => {
      Utils.updateBi(keys.PAYOUT_MODE, field.value.id, props.data.product_id, formRef, props)
    }
  })

  // Addtional Rider

  formRef.$('ADB').observe({
    key: 'value',
    call: ({ field }) => {
      let adbValue = formRef.$('ADB-dropdown').value
      Utils.updateBi(keys.ADB_RIDER, adbValue, props.data.product_id, formRef, props)
    }
  })

  formRef.$('ATPDRider').observe({
    key: 'value',
    call: ({ field }) => {
      let atpdValue = formRef.$('ATPDRider-dropdown').value
      Utils.updateBi(keys.ATPD_RIDER, atpdValue, props.data.product_id, formRef, props)
    }
  })

  formRef.$('WaiverOfPremiumRider').observe({
    key: 'value',
    call: ({ field }) => {
      let value = '';
      if (field.value) {
        value = "1"
      }

      Utils.updateBi(keys.WOP_RIDER, value, props.data.product_id, formRef, props)
    }
  })

  formRef.$('IncomeBenefitRider').observe({
    key: 'value',
    call: ({ field }) => {
      let incomeBuilder = formRef.$('IncomeBenefitRider-dropdown').value
      Utils.updateBi(keys.INCOME_BENEFIT_RIDER, incomeBuilder, props.data.product_id, formRef, props)
    }
  })

  formRef.$('PayorWaiverBenefitRider-dropdown').observe({
    key: 'value',
    call: ({ field }) => {
      Utils.updateBi(keys.PWB_RIDER, field.value.id, props.data.product_id, formRef, props)
    }
  })

}

export default FormObserver